angular.module('dpw.directives')

    /**
     * @ngdoc directive
     * @name dpwWizard
     *
     * @param {Object} config                           - Configuration for the wizard
     * @param {String} config.title                     - Title for the wizard
     * @param {Function} [config.onInit]                - Invoked with the wizard controller as parameter on initialization
     * @param {Function} [config.postLink]              - Invoked with the wizard controller as parameter on DOM ready
     * @param {String} [config.submitBtnLabel]
     * @param {Boolean} [config.isSubmitDisabled]
     * @param {Boolean} [config.hideCloseBtn]
     *
     * @Note
     * 0. Please use service `wizard` to create a wizard.
     *
     * 1. The `config` object will be assigned to the wizard controller, and you can attach some properties to the wizard controller through "the `config` object", "config.onInit" or "config.postLink".
     * 2. Please make sure the wizard controller contains the following properties:
     *      @param {Array<Object>} ctrl.stepsConfig                 - Configuration objects for all steps (each configuration object should follow the documentation of service `StepManager`)
     *      @param {String} ctrl.stepsConfig[index].templateUrl     - ID of a template to be included for the step
     *      @param {Function} ctrl.submit                           - Invoked on submission of the last step
     *      @param {Function} ctrl.close                            - Invoke to close the wizard (if the wizard is created by service `wizard`, this property is pre-filled)
     */
    .directive('dpwWizard', [function () {
        return {
            restrict: 'EA',
            scope: true,
            templateUrl: 'dpw-wizard.html',
            controllerAs: 'ctrl',
            controller: ['$scope', 'StepManager', function ($scope, StepManager) {
                var ctrl = this;
                _.assign(ctrl, $scope.config);

                ctrl.$onInit = function () {
                    _.isFunction(ctrl.onInit) && ctrl.onInit(ctrl);
                };

                ctrl.$postLink = function () {
                    _.isFunction(ctrl.postLink) && ctrl.postLink(ctrl);

                    ctrl.stepManager = new StepManager(ctrl.stepsConfig, ctrl);
                };
            }]
        };
    }])

;